export const DEVICE_SETTINGS = {
  OLD_DEVICE_SETTINGS_CAMERA_CHANGED: 'OLD_DEVICE_SETTINGS_CAMERA_CHANGED',
}